module.exports = __webpack_public_path__ + "static/media/card-game-bg.ae0338cb.png";